import startsWith from 'lodash.startswith'
import memoize from 'lodash.memoize'

import albumsManifest from './albums-manifest.json'

const makeCacheKey = (...keys) => keys.join('.')

export const selectAlbumPhotoList = memoize(
  album => Object.keys(albumsManifest[album]).sort(
    (a, b) => {
      a = parseInt(a, 10)
      b = parseInt(b, 10)
      if (a === b) return 0
      if (a > b) return 1
      return -1
    }
  )
)

export function selectPhoto (album, photo, preset) {
  return albumsManifest[album][photo][preset]
}

export const selectIndexForPhoto = memoize(
  (album, photo) => selectAlbumPhotoList(album).indexOf(photo),
  makeCacheKey
)

export function selectPhotoForIndex (album, index) {
  return selectAlbumPhotoList(album)[index]
}

export function selectPresetsWithPrefix (album, photo, presetPrefix) {
  return Object.keys(albumsManifest[album][photo])
    .filter(key => startsWith(key, presetPrefix))
    .sort()
}

export function selectSrc (album, photo, preset) {
  return `/static/media/albums/${album}/${selectPhoto(album, photo, preset).src}`
}

export const selectSrcSetPrefix = memoize(
  (album, photo, presetPrefix) => selectPresetsWithPrefix(album, photo, presetPrefix)
    .map(preset => `${selectSrc(album, photo, preset)} ${selectPhoto(album, photo, preset).width}w`)
    .join(',\n'),
  makeCacheKey
)

export const selectPhotoBrowserItems = memoize(
  album => selectAlbumPhotoList(album).map(photo => ({
    sizes: `100vw`,
    srcSet: selectSrcSetPrefix(album, photo, 'hd'),
    original: selectSrc(album, photo, 'hd1x'),
    originalAlt: photo,
  }))
)



// WEBPACK FOOTER //
// ./src/albumSelectors.js